export const createInitialState = (urlArray, pubMedArray, notFoundArray) => ({
  urlFound: urlArray,
  found: pubMedArray,
  notFoundArray,
});

export const createFinalState = (final, multipleFound) => ({
  found: final,
  multipleFound,
});

export const updateProgress = (current, total) => {
  const percentage = Math.floor((current / total) * 100);
  return percentage;
};